
import {defineComponent, PropType} from 'vue';
import FieldError from "@/components/forms/FieldError.vue";

// type FormErrors = Record<string, string[]>;

export default defineComponent({
    name: 'TextField',
    components: {
        FieldError,
    },
    emits: [
        'update:modelValue',
    ],
    props: {
        modelValue: {
            type: String,
            required: false,
        },
        prefix: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        field: {
            type: String,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
        type: {
            type: String,
            required: false,
            default: 'text',
            /*validator(value: string) { // breaks typescript, why tho?
                return ['text', 'textarea'].includes(value);
            },*/
        },
    },
    data() {
        return {
        };
    },
    computed: {
        id() {
            return this.prefix + '-input-' + this.field;
        },
        fieldErrors() {
            return (typeof this.errors !== 'undefined' && typeof this.errors[this.field] !== 'undefined' ? this.errors[this.field] : null) || [];
        },
        hasError() {
            return this.fieldErrors.length > 0;
        },
    },
});
